import { render, staticRenderFns } from "./ArtistDomain.vue?vue&type=template&id=6a2c2795&scoped=true&"
import script from "./ArtistDomain.vue?vue&type=script&lang=js&"
export * from "./ArtistDomain.vue?vue&type=script&lang=js&"
import style0 from "./ArtistDomain.vue?vue&type=style&index=0&id=6a2c2795&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c2795",
  null
  
)

export default component.exports